import { Navigate, RouteObject } from "react-router-dom";

import AuthPage from "@/pages/auth";
import AccessDenied from "@/pages/auth/access-denied";
import DashboardPage from "@/pages/dashboard";
import ErrorBoundaryPage from "@/pages/error-boundary";
import { APP_ROUTES } from "./routes";

const configAppRoutes: RouteObject[] = [
  {
    path: APP_ROUTES.VERIFY.path,
    element: <AuthPage />,
  },
  {
    path: APP_ROUTES.ACCESS_DENIED.path,
    element: <AccessDenied />,
  },
  {
    path: APP_ROUTES.DASHBOARD.path,
    element: <DashboardPage />,
  },
  {
    path: APP_ROUTES.NOT_FOUND.path,
    element: <ErrorBoundaryPage />,
  },
  {
    path: "*",
    element: <Navigate to={APP_ROUTES.NOT_FOUND.path} />,
  },
];

export default configAppRoutes;
